const ZoomOutIcon = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.0513 27.6934L37.1892 34.8312L34.8322 37.1882L27.6943 30.0504C25.1278 32.1037 21.873 33.332 18.333 33.332C10.053 33.332 3.33301 26.612 3.33301 18.332C3.33301 10.052 10.053 3.33203 18.333 3.33203C26.613 3.33203 33.333 10.052 33.333 18.332C33.333 21.872 32.1047 25.1269 30.0513 27.6934ZM16.6663 16.6654H11.6663V19.9987H16.6663V24.9987H19.9997V19.9987H24.9997V16.6654H19.9997V11.6654H16.6663V16.6654Z"
        fill="#322D24"
      />
    </svg>
  );
};

export default ZoomOutIcon;
